/*
 *
 * ProtectNetworksModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import { connect } from 'react-redux'
import { doHidePopup } from 'Store/actions/popup'
import { bindActionCreators } from 'redux'
import UseAntivirusSoftware from './UseAntivirusSoftware'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = state => ({
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(UseAntivirusSoftware)
